<template>
    <div v-if="slides.length">
        <VueSlickCarousel
            :arrows="false"
            :dots="true"
            :adaptiveHeight="false"
            class="slider"
        >
            <div v-for="slide in slides" :key="slide.id">
                <img :src="slide.path" />
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: "Slider",
    components: { VueSlickCarousel },
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
